import { setProfileState, resetProfileState } from './profile/actions';
import { setCalculateState, resetCalculateState } from './calculate/actions';
import { resetWebMaterialState, setWebMaterialState } from './material/actions';

export function setWebServicesState(state) {
  return dispatch => {
    dispatch(setProfileState(state.profile));
    dispatch(setCalculateState(state.calculate));
    dispatch(setWebMaterialState(state.material));
  };
}

export function resetWebServicesState() {
  return dispatch => {
    dispatch(resetProfileState());
    dispatch(resetCalculateState());
    dispatch(resetWebMaterialState());
  };
}



// WEBPACK FOOTER //
// ./src/reducers/web-services/actions.js